module.exports = __webpack_public_path__ + "media/images/no_email_history-d08cdffd07a0760fcd7fe4f746d0109b.svg";